import type { ReactNode } from 'react'

export type LandingIconName = 'arrow' | 'menu' | 'close' | 'play' | 'order' | 'user' | 'gift' | 'truck' | 'check'

const paths: Record<LandingIconName, ReactNode> = {
  arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  play: <path d="m9 5 11 7-11 7Z" />,
  order: <path d="M8 4H5v17h14V4h-3M8 3h8v4H8zM8 12h8M8 16h5" />,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a8 8 0 0 1 16 0v2" /></>,
  gift: <><path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13" /><path d="M12 8C5 8 4 3 7 3s5 5 5 5 2-5 5-5 2 5-5 5Z" /></>,
  truck: <><path d="M3 5h11v12H3zM14 10h4l3 4v3h-7" /><circle cx="7" cy="18" r="2" /><circle cx="17" cy="18" r="2" /></>,
  check: <path d="m5 12 4 4L19 6" />,
}

export function MemberLandingIcon({ name, className }: { name: LandingIconName; className?: string }) {
  return <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">{paths[name]}</svg>
}
